<template>
  <div class="body">
    <van-nav-bar title="我的帮助" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
  </div>
</template>

<script>
import NoData from "@/components/NoData.vue";
import { GetAddress } from "../../apis/https.js";
import { getSessionStorage } from "../../utils/storage.js";
// import { Checkbox, CheckboxGroup } from "vant";
// import Vue from "vue";
// Vue.use(Checkbox).use(CheckboxGroup);
export default {
  components: {
    NoData
  },
  data() {
    return {
      hasData:false,
    };
  },
  created() {

  },
  activated(){
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: #f4f8fb;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content{
    margin-top: 46px;
  }
}
</style>